import { stringify } from 'query-string';
import { apiGetOne } from './ApiBaseActions';
export const API_GET_COMPARISON = 'API_GET_COMPARISON';
export const API_GET_COMPARISON_SUCCESS = 'API_GET_COMPARISON_SUCCESS';
export const API_GET_COMPARISON_FILE = 'API_CARD_UPLOAD';
const getParam = (ids) => stringify({ checks: JSON.stringify(ids) });
export const apiGetComparison = (ids, meta) => apiGetOne(API_GET_COMPARISON, `/client/solution/favorite/comparison/?${getParam(ids)}`, meta);
export const apiGetComparisonFile = (ids, fileName, meta) => apiGetOne(API_GET_COMPARISON_FILE, `/client/solution/favorite/comparison/download?${getParam(ids)}`, Object.assign(Object.assign({}, meta), { fileName, isBlob: true }));
